import request from "@/request/request";

// 获取账号类型字典值
export const getDic = (data) => {
  return request({
    url:'/api/login/queryRorgList',
    method:'POST',
    data,
  })
};